import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {finalize, Subject, takeUntil, forkJoin, Observable, firstValueFrom} from 'rxjs';
import {BreadcrumbService} from 'src/app/service/breadcrumb.service';
import {Grupo} from 'src/app/models/grupo.model';
import {GruposService} from 'src/app/service/grupos.service';
import {DataTablePage} from 'src/app/models/data-table-page.model';
import {UserService} from 'src/app/service/user.service';
import {StorageKeys} from 'src/app/shared/enums/storage-keys.enum';
import {OccurrenceService} from 'src/app/service/occurrence.service';
import {MotiveOccurrence} from 'src/app/models/occurrence.model';
import {ConfirmationService, MessageService} from 'primeng/api';
import {RoutesEnum} from 'src/app/shared/enums/routes.enum';
import {Router} from '@angular/router';
import {OccurrenceFilterModel} from 'src/app/models/occurrence-filter.model';
import { Contract } from 'src/app/models/user.model';
import { Occurrence, Attachment } from 'src/app/models/occurrence.model';
import { FileUpload } from 'primeng/fileupload';
import { DeviceService } from 'src/app/service/devices.service';
import { GA4Service } from 'src/app/service/ga4.service';

interface PreviewState {
  visible: boolean;
  loading: boolean;
  fileName: string;
  kind: 'image' | 'pdf' | 'json' | 'xlsx' | null;
  objectUrl: string | null;
  safeResourceUrl: SafeResourceUrl | null;
  text: string;
  rows: string[][];
}

@Component({
  selector: 'app-occurrence',
  templateUrl: './occurrence.component.html',
  styleUrls: ['./occurrence.component.scss']
})

export class OccurrenceComponent implements OnInit, OnDestroy {

  @ViewChild('fileUpload') fileUpload!: FileUpload;

  private _destroy$: Subject<void> = new Subject<void>();

  stylePattern = {'min-width': '100%', 'max-width': '100%', 'height': '40px'};

  isVisible: boolean = false;
  isNotesVisible: boolean = false;
  selectedNotes: string = '';
  selectedNotesDescription: string = '';
  selectedNotesOccurrence: any = null;
  originalNotes: string = '';
  notesLoading: boolean = false;
  uploadedFiles: any[] = [];
  attachments: Attachment[] = [];
  attachmentsToDelete: number[] = [];
  currentOccurrence: any = null;
  readonly MAX_ATTACHMENTS= 5;
  readonly MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

  preview: PreviewState | null = null;
  private readonly PREVIEW_ERROR_MESSAGE = 'Não foi possível visualizar o arquivo.';

  page!: DataTablePage;
  loading: boolean = false;
  first: number = 0;
  totalRecords: number = 0;

  currentFilter: any = [];
  rangeDates: Date[] = [];
  maxDate: Date = new Date();

  contracts!: Array<Contract>;
  operations!: any;

  occurrenceData: Occurrence[] = [];

  occurrenceFilter: any = new OccurrenceFilterModel();
  motives: MotiveOccurrence[] = []
  devices: any[] = [];
  lotes: Array<{ id: string, description: string }> = [];
  selectedLotes: any[] = [];
  devicesLoteMap = new Map<any, string>
  allDevices: Array<any> = [];
  loadDevices: boolean = false;
  lanes: any[] = [];
  filters: any = new OccurrenceFilterModel();

  // occurrenceType = [
  //   {name: 'Técnico', value: 'technical'},
  //   {name: 'Não técnico', value: 'nonTechnical'},
  // ];

  exportLoading: boolean = false;
  exportReady: boolean = false;
  private exportBlob: Blob | null = null;
  
  notFound: boolean = false;
  tituloNotFound: string = 'Nenhuma ocorrência encontrada';
  descricaoNotFound: string = 'Desculpe, não encontramos nenhuma ocorrência para os filtros informados';
  selectedSort: string = '';
  sortDirection: number = 0;

columns = [
  { field: 'userName',         label: 'Criador',     width: '10%'  },
  { field: 'description',      label: 'Descrição',   width: '15%' },
  { field: 'equipmentName',    label: 'Equipamento', width: '15%' },
  { field: 'lane',             label: 'Pista',       width: '15%' },
  { field: 'motiveOccurrence', label: 'Motivo',      width: '10%' },
  { field: 'startDate',        label: 'Data Início', width: '20%' },
  { field: 'endDate',          label: 'Data Fim',    width: '20%' },
];
  constructor(
    private breadCrumb: BreadcrumbService,
    private occurrenceService: OccurrenceService,
    private gruposService: GruposService,
    private router: Router,
    private userService: UserService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private deviceService: DeviceService,
    private ga4Service: GA4Service,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {
    this.page = new DataTablePage();
    this.page.pageNumber = 0;
  }

  ngOnInit(): void {
    this.breadCrumb.next([
      {label: 'Configurações', icon: 'pi pi-sliders-v'},
      {label: 'Ocorrência', icon: 'pi pi-history'}
    ]);
    this.getContract();
    this.occurrenceService.setOccurreceInUse(null);
    this.rangeDates[0] = this.occurrenceFilter.startDate;
    this.rangeDates[1] = this.occurrenceFilter.endDate;
    this.ga4Service.trackActiveUserByScreen('Ocorrência', 'Ocorrência');
  }

  showDialog(occurrence: any) {
    this.currentOccurrence = occurrence;
    this.uploadedFiles = [];
    this.attachments = occurrence.attachments || [];

    this.loading = true;
    this.occurrenceService.getAttachments(occurrence.id)
    .pipe(
      takeUntil(this._destroy$),
      finalize(() => this.loading = false)
    )
    .subscribe({
      next: (attachments) => {
          this.attachments = attachments || [];
      },
      error: (e) => {
        console.error('Erro ao carregar anexos', e);
        this.messageService.add({
          key: 'toastError',
          severity: 'error',
        });
      }
    });
    this.isVisible = true;
  }

  onFileSelect(event: any) {
    const newFiles = event.currentFiles || event.files;

    if (!newFiles || newFiles.length === 0) {
      return;
    }

    for (let file of newFiles) {
      const totalCount = this.getActiveAttachmentsCount();

      if (totalCount >= this.MAX_ATTACHMENTS) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Limite atingido',
          detail: `Você só pode ter até ${this.MAX_ATTACHMENTS} anexos`,
          key: 'toastError'
        });
        break;
      }

      this.uploadedFiles.push(file);
    }

    if (this.fileUpload) {
      this.fileUpload.clear();
    }
  }

  hasChanges(): boolean {
    return this.attachmentsToDelete.length > 0 || this.uploadedFiles.length > 0;
  }

  getContract(): void{
    const contratoSelecionado: any = this.userService.getCurrentContractAsList();

    if(!contratoSelecionado[0]?.id){
      return
    }

    this.occurrenceFilter.contractId = contratoSelecionado[0]?.id;
    this.contracts = contratoSelecionado;

    this.getMotives();
    this.getLanes();
    this.getOperations();
    this.getDevices();

    this.loadDevices = true;
  }

  getMotives(): void {
    if(this.occurrenceFilter.contractId) {
      this.occurrenceService.getAllMotiveOccurrence(this.occurrenceFilter.contractId)
      .pipe(takeUntil(this._destroy$))
      .subscribe(r => this.motives = (r ?? []).sort((a, b) =>
        a.description.localeCompare(b.description, 'pt-BR', { numeric: true })));
    }
  }

  getLanes(): void{
    if(this.occurrenceFilter.contractId) {
      this.occurrenceService.getLanes(this.occurrenceFilter.contractId)
      .pipe(takeUntil(this._destroy$))
      .subscribe((r: any) => this.lanes = (r.organCod ?? []).sort((a: string, b: string) =>
        a.localeCompare(b, 'pt-BR', { numeric: true })));
    }
  }

  getOperations(): void {
  }

  getDevices() {
    this.deviceService.getDeviceMetrics()
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (response: any) => {
          const uniqueDevices = new Map<string, { deviceId: any; deviceName: string }>();

          response.forEach((item: any) => {
            if (!uniqueDevices.has(item.deviceName)) {
              uniqueDevices.set(item.deviceName, {
                deviceId: item.equipmentOriginId,
                deviceName: item.deviceName,
              });
            }
          });
          this.devices = Array.from(uniqueDevices.values()).sort((a, b) =>
            a.deviceName.localeCompare(b.deviceName, 'pt-BR', { numeric: true }));

          this.allDevices = Array.from(uniqueDevices.values()).sort((a, b) =>
            a.deviceName.localeCompare(b.deviceName, undefined, { numeric: true, sensitivity: 'base' })
          );
          this.devices = [...this.allDevices];

          this.devicesLoteMap = this.buildDevicesLoteMap(response);
          this.lotes = this.buildLoteOptions(response);
        },
        error: (e) => {
          console.error(e);
          this.loadDevices = false;
        },
        complete: () => {
          this.loadDevices = false;
        }
      });

  }

    private buildLoteOptions(data: any[] = []) {
    const lotes = new Set(
      (data ?? [])
        .map(device => this.getDeviceLote(device))
        .filter(lote => lote !== '')
    );

    return Array.from(lotes)
      .map(lote => ({
        id: lote,
        description: lote,
      }))
      .sort((a, b) => a.description.localeCompare(b.description, undefined, {numeric: true}));
  }

  private buildDevicesLoteMap(data: any[] = []) {
    const devicesLoteMap = new Map<string, string>();

    (data ?? []).forEach(device => {
      if (device?.deviceName) {
        devicesLoteMap.set(device.deviceName, this.getDeviceLote(device));
      }
    });

    return devicesLoteMap;
  }

  private getDeviceLote(device: any): string {
    return device?.lote != null ? String(device.lote) : '';
  }

  loteModelChanges(value: string[]) {
    this.selectedLotes = value ?? [];

    if (this.selectedLotes.length === 0) {
      this.devices = [...this.allDevices];
      this.occurrenceFilter.device = null;
    } else {
      this.devices = this.allDevices
        .filter(device =>
          this.selectedLotes.includes(this.devicesLoteMap.get(device.deviceName) ?? '')
        )
        .sort((a, b) =>
          a.deviceName.localeCompare(b.deviceName, undefined, { numeric: true, sensitivity: 'base' })
        );

      this.occurrenceFilter.device = this.devices.map(device => device.deviceId);
    }
  }

  onLazyLoad(event: any) {
  this.notFound = false;
  this.loading = true;

  this.page.size = event.rows;

  this.page.pageNumber = event.first / event.rows;

    if (event.sortField) {
      if (this.selectedSort === event.sortField) {
        if (this.sortDirection === 1) {
          this.sortDirection = -1;
        } else if (this.sortDirection === -1) {
          this.sortDirection = 0;
          this.selectedSort = '';
          event.sortField = null;
          event.sortOrder = null;
        }
      } else {
        this.selectedSort = event.sortField;
        this.sortDirection = 1;
      }
    } else {
      this.selectedSort = '';
      this.sortDirection = 0;
    }


    this.currentFilter = {
      // operation: this.occurrenceFilter.operation,
      motiveOccurrence: this.occurrenceFilter.motiveOccurrence,
      device: this.occurrenceFilter.device,
      // type: this.occurrenceFilter.type,
      // rejected: this.occurrenceFilter.rejected,
      hasAttachment: this.occurrenceFilter.hasAttachment,
      hasNotes: this.occurrenceFilter.hasNotes,
      lane: this.occurrenceFilter.lane,
      startDate: this.occurrenceFilter.startDate,
      endDate: this.occurrenceFilter.endDate,
      contractId: this.occurrenceFilter.contractId,
      sortBy: this.sortDirection !== 0 ? this.selectedSort : null,
      sortOrder: this.sortDirection === 1 ? 'asc' : this.sortDirection === -1 ? 'desc' : null
    };

    this.occurrenceService.getOccurrence(this.page, this.currentFilter)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (data: any) => {
          this.totalRecords = this.page.totalElements;
          this.occurrenceData = data.content;
          if (!data.content || data.content.length === 0) {
            this.notFound = true;
            this.tituloNotFound = 'Nenhuma ocorrência encontrada';
            this.descricaoNotFound = 'Desculpe, não encontramos nenhuma ocorrência para os filtros informados';
          }
        }
      })
  }

  markAttachmentForDeletion(attachmentId: number) {
    if (!this.attachmentsToDelete.includes(attachmentId)) {
      this.attachmentsToDelete.push(attachmentId);
    }
  }

  unmarkAttachmentForDeletion(attachmentId: number) {
    const index = this.attachmentsToDelete.indexOf(attachmentId);
    if (index > -1) {
      this.attachmentsToDelete.splice(index, 1);
    }
  }

  isMarkedForDeletion(attachmentId: number): boolean {
    return this.attachmentsToDelete.includes(attachmentId);
  }

  removeNewFile(index: number) {
    this.uploadedFiles.splice(index, 1);
  }

  getActiveAttachmentsCount(): number {
    const activeAttachments = this.attachments.length - this.attachmentsToDelete.length;
    return activeAttachments + this.uploadedFiles.length;
  }

  cancelDialog() {
    this.isVisible = false;
    this.uploadedFiles = [];
    this.attachmentsToDelete = [];
    this.currentOccurrence = null;

    if (this.fileUpload) {
      this.fileUpload.clear();
    }
  }

  onDownloadAttachment(attachment: Attachment) {
    this.occurrenceService.getAttachmentPreview(attachment.id)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (bytes) => this.download(
          attachment.name || 'download',
          new Blob([bytes], {type: attachment.type || 'application/octet-stream'})
        ),
        error: (error) => {
          console.error('Erro ao baixar anexo:', error);
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao baixar anexo',
          });
        }
      });
  }

  private download(name: string, blob: Blob) {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = name || 'download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  }

  canPreview(name: string): boolean {
    return this.getPreviewKind(name) !== null;
  }

  onPreviewAttachment(attachment: Attachment) {
    this.loadAndPreview(
      attachment.name,
      firstValueFrom(this.occurrenceService.getAttachmentPreview(attachment.id).pipe(takeUntil(this._destroy$))),
      attachment.type
    );
  }

  onPreviewFile(file: File) {
    this.loadAndPreview(file.name, file.arrayBuffer(), file.type);
  }

  closePreview() {
    if (this.preview?.objectUrl) {
      URL.revokeObjectURL(this.preview.objectUrl);
    }
    this.preview = null;
  }

  private openPreview(fileName: string) {
    this.closePreview();
    this.preview = {
      visible: true,
      loading: true,
      fileName,
      kind: null,
      objectUrl: null,
      safeResourceUrl: null,
      text: '',
      rows: []
    };
  }

  private async loadAndPreview(fileName: string, bytes: Promise<ArrayBuffer>, mimeType?: string) {
    this.openPreview(fileName);

    try {
      const previewKind = this.getPreviewKind(fileName);
      if (!previewKind) {
        throw new Error('Unsupported preview type');
      }

      const fileBytes = await bytes;
      const loadedPreview: PreviewState = {
        visible: true,
        loading: false,
        fileName,
        kind: previewKind,
        objectUrl: null,
        safeResourceUrl: null,
        text: '',
        rows: []
      };

      if (previewKind === 'image') {
        loadedPreview.objectUrl = this.getImageObjectUrl(fileBytes, fileName, mimeType);
      } else if (previewKind === 'pdf') {
        loadedPreview.objectUrl = this.getPdfObjectUrl(fileBytes);
        loadedPreview.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(loadedPreview.objectUrl);
      } else if (previewKind === 'json') {
        loadedPreview.text = this.getJsonText(fileBytes);
      } else {
        loadedPreview.rows = await this.getXlsxRows(fileBytes);
      }

      if (this.preview?.fileName !== fileName) {
        if (loadedPreview.objectUrl) {
          URL.revokeObjectURL(loadedPreview.objectUrl);
        }
        return;
      }

      this.preview = loadedPreview;
    } catch (error) {
      console.error('Erro ao processar preview:', error);
      this.showPreviewError();
    } finally {
      this.cdr.detectChanges();
    }
  }

  private showPreviewError() {
    this.closePreview();
    this.messageService.add({
      key: 'toastError',
      severity: 'error',
      summary: 'Erro',
      detail: this.PREVIEW_ERROR_MESSAGE,
    });
  }

  private getPreviewKind(fileName?: string): 'image' | 'pdf' | 'json' | 'xlsx' | null {
    const extension = fileName?.split('.').pop()?.toLowerCase();

    if (['png', 'jpg', 'jpeg', 'webp'].includes(extension || '')) return 'image';
    if (extension === 'pdf') return 'pdf';
    if (extension === 'json') return 'json';
    if (extension === 'xlsx') return 'xlsx';

    return null;
  }

  private getImageObjectUrl(bytes: ArrayBuffer, fileName: string, mimeType?: string): string {
    const blob = new Blob([bytes], {type: mimeType || this.getImageMimeType(fileName)});
    return URL.createObjectURL(blob);
  }

  private getPdfObjectUrl(bytes: ArrayBuffer): string {
    if (new TextDecoder('utf-8').decode(bytes.slice(0, 5)) !== '%PDF-') {
      throw new Error('Invalid PDF file');
    }
    return URL.createObjectURL(new Blob([bytes], {type: 'application/pdf'}));
  }

  private getJsonText(bytes: ArrayBuffer): string {
    const text = new TextDecoder('utf-8').decode(bytes).replace(/^\uFEFF/, '');
    return JSON.stringify(JSON.parse(text), null, 2);
  }

  private async getXlsxRows(bytes: ArrayBuffer): Promise<string[][]> {
    const XLSX = await import('xlsx');
    const workbook = XLSX.read(bytes, {type: 'array'});
    const sheetName = workbook.SheetNames[0];

    if (!sheetName) {
      throw new Error('XLSX file has no sheets');
    }

    const rows = XLSX.utils.sheet_to_json<any[]>(workbook.Sheets[sheetName], {
      header: 1,
      blankrows: false
    });

    return rows
      .slice(0, 100)
      .map((row) => row
        .slice(0, 30)
        .map((cell) => cell == null ? '' : String(cell)));
  }

  private getImageMimeType(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase();
    if (extension === 'png') return 'image/png';
    if (extension === 'webp') return 'image/webp';
    return 'image/jpeg';
  }

  saveAttachments() {
    if (!this.currentOccurrence) {
      return;
    }

    this.loading = true;

    const deleteRequests = this.attachmentsToDelete.map(id =>
      this.occurrenceService.deleteAttachment(id)
    );

    if (deleteRequests.length > 0) {
      this.executeDeletes(deleteRequests);
    } else {
      this.executeUploads();
    }
  }

  private executeDeletes(deleteRequests: Observable<any>[]) {
    forkJoin(deleteRequests)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => {
          if (this.uploadedFiles.length === 0) {
            this.loading = false;
          }
        })
      )
      .subscribe({
        next: () => {
          this.messageService.add({
            key: 'toastSuccess',
            severity: 'success',
            detail: 'Anexos removidos com sucesso',
          });

          if (this.uploadedFiles.length > 0) {
            this.executeUploads();
          } else {
            this.finishAttachmentOperation();
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('Erro ao deletar anexos:', error);
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao remover anexos',
          });
        }
      });
  }

  private executeUploads() {
    const userId = this.userService.user.id
    this.occurrenceService.saveAttachments(this.currentOccurrence.id, this.uploadedFiles, userId)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: () => {
          this.messageService.add({
            key: 'toastSuccess',
            severity: 'success',
            detail: 'Anexos salvos com sucesso',
          });
          this.finishAttachmentOperation();
        },
        error: (error) => {
          console.error('Erro ao fazer upload:', error);
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao salvar anexos',
          });
        }
      });
  }

  private finishAttachmentOperation() {
    this.isVisible = false;
    this.uploadedFiles = [];
    this.attachmentsToDelete = [];
    this.currentOccurrence = null;

    if (this.fileUpload) {
      this.fileUpload.clear();
    }

    this.loadOccurrences();
  }

  customSort(field: string) {
    if (this.selectedSort === field) {
      if (this.sortDirection === 1) {
        this.sortDirection = -1;
      } else if (this.sortDirection === -1) {
        this.sortDirection = 0;
        this.selectedSort = '';
        field = '';
      }
    } else {
      this.selectedSort = field;
      this.sortDirection = 1;
    }

    this.loadOccurrences();
  }

  getSortIconClass(field: string) {
    const isSelected = this.selectedSort === field;

    if (!isSelected || this.sortDirection === 0) return 'pi-sort-alt';
    return this.sortDirection === 1 ? 'pi-sort-amount-up' : 'pi-sort-amount-down';
  }

  loadOccurrences() {
    this.notFound = false;
    this.loading = true;

    this.currentFilter = {
      // operation: this.occurrenceFilter.operation,
      motiveOccurrence: this.occurrenceFilter.motiveOccurrence,
      // type: this.occurrenceFilter.type,
      // rejected: this.occurrenceFilter.rejected,
      hasAttachment: this.occurrenceFilter.hasAttachment,
      hasNotes: this.occurrenceFilter.hasNotes,
      lane: this.occurrenceFilter.lane,
      startDate: this.occurrenceFilter.startDate,
      endDate: this.occurrenceFilter.endDate,
      contractId: this.occurrenceFilter.contractId,
      device: this.occurrenceFilter.device,
      sortBy: this.sortDirection !== 0 ? this.selectedSort : null,
      sortOrder: this.sortDirection === 1 ? 'asc' : this.sortDirection === -1 ? 'desc' : null
    };

    console.log('Current Filter:', this.currentFilter);
    this.occurrenceService.getOccurrence(this.page, this.currentFilter)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (data: any) => {
          this.totalRecords = this.page.totalElements;
          this.occurrenceData = data.content;
          if (!data.content || data.content.length === 0) {
            this.notFound = true;
            this.tituloNotFound = 'Nenhuma ocorrência encontrada';
            this.descricaoNotFound = 'Desculpe, não encontramos nenhuma ocorrência para os filtros informados';
          }
        }
      })
  }

  getOccurrence(pageEvent: any, filters: any) {
    this.notFound = false;
    this.loading = true;

    if (pageEvent === false) {
      this.page.pageNumber = 0;
      this.first = 0;
      this.selectedSort = '';
      this.sortDirection = 0;

      if (this.rangeDates !== undefined) {
        this.occurrenceFilter.startDate = this.rangeDates[0];
        this.occurrenceFilter.endDate = this.rangeDates[1];
      }
      if (
        this.rangeDates === undefined &&
        this.occurrenceFilter.startHour !== undefined &&
        this.occurrenceFilter.endHour !== undefined
      ) {
        this.occurrenceFilter.startDate = new Date(this.occurrenceFilter.startHour);
        this.occurrenceFilter.endDate = new Date(this.occurrenceFilter.endHour);
      }
    }

    if(filters === false){
      filters = {};
    }

    this.currentFilter = {
      // operation: filters.operation,
      motiveOccurrence: filters.motiveOccurrence,
      // type: filters.type,
      // rejected: filters.rejected,
      hasAttachment: filters.hasAttachment,
      hasNotes: filters.hasNotes,
      lane: filters.lane,
      startDate: filters.startDate,
      endDate: filters.endDate,
      contractId: this.occurrenceFilter.contractId,
      device: filters.device,
      sortBy: this.sortDirection !== 0 ? this.selectedSort : null,
      sortOrder: this.sortDirection === 1 ? 'asc' : this.sortDirection === -1 ? 'desc' : null
    };

    this.occurrenceService.getOccurrence(this.page, this.currentFilter)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (data: any) => {
          this.totalRecords = this.page.totalElements;
          this.occurrenceData = data.content;
          if (!data.content || data.content.length === 0) {
            this.notFound = true;
            this.tituloNotFound = 'Nenhuma ocorrência encontrada';
            this.descricaoNotFound = 'Desculpe, não encontramos nenhuma ocorrência para os filtros informados';
          }
        }
      })
  }

  openNotes(occurrence: any) {
    this.selectedNotesOccurrence = occurrence;
    this.selectedNotes = occurrence.notes || '';
    this.originalNotes = occurrence.notes || '';
    this.selectedNotesDescription = occurrence.description || '';
    this.isNotesVisible = true;
  }

  hasNotesChanged(): boolean {
    return this.selectedNotes !== this.originalNotes;
  }

  cancelNotes() {
    this.isNotesVisible = false;
    this.selectedNotes = '';
    this.originalNotes = '';
    this.selectedNotesOccurrence = null;
  }

  saveNotes() {
    if (!this.selectedNotesOccurrence || !this.hasNotesChanged()) return;

    this.notesLoading = true;

    const motiveOccurrence = this.selectedNotesOccurrence.motiveOccurrence?.id
      ?? this.selectedNotesOccurrence.motiveOccurrence;

    this.occurrenceService.updateOccurrence({
      ...this.selectedNotesOccurrence,
      notes: this.selectedNotes,
      motiveOccurrence,
      originId: this.selectedNotesOccurrence.equipment
    })
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.notesLoading = false)
      )
      .subscribe({
        next: () => {
          this.messageService.add({
            key: 'toastSuccess',
            severity: 'success',
            detail: 'Anotação salva com sucesso',
          });
          this.cancelNotes();
          this.loadOccurrences();
        },
        error: (error) => {
          console.error('Erro ao salvar anotação:', error);
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao salvar anotação',
          });
        }
      });
  }

  openEdit(occurrence: any){
    occurrence.motiveOccurrence = occurrence.motiveOccurrence.id
    console.log(occurrence.equipment)
    occurrence.originId = occurrence.equipment
    this.occurrenceService.setOccurreceInUse(occurrence);
    this.router.navigate([RoutesEnum.MONITORING_NEW_OCCURRENCE]).then(() => {
    })
  }

  openDeleteConfirm(id: number, desc: string) {
    this.confirmationService.confirm({
      message: 'Você realmente deseja deletar a ocorrência: ' + desc,
      header: 'Deletar ocorrência',
      acceptLabel: 'Excluir',
      rejectLabel: 'Cancelar',
      acceptIcon: 'pi pi-trash mr-1',
      rejectIcon: 'pi pi-times mr-1',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary mr-2',
      accept: () => this.deleteOccurrence(id),
      reject: () => { }
    })
  }

  deleteOccurrence(occurrenceId: number) {
    this.occurrenceService.deleteOccurrence(occurrenceId)
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe({
        next: () => {
          this.messageService.add({
            key: 'toastSuccess',
            severity: 'success',
            detail: 'Ocorrência excluída com sucesso!',
          });
          this.getOccurrence(this.page, this.currentFilter);
        },
        error: (e) => {
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Error',
            detail: 'Erro ao tentar excluir ocorrência',
          });
        },
      })
  }

  goToNewOccurrence(){
    this.router.navigate([RoutesEnum.MONITORING_NEW_OCCURRENCE])
  }

  exportOccurrences() {
    this.exportLoading = true;
    this.exportReady = false;
    this.exportBlob = null;

    const filter = {
      motiveOccurrence: this.currentFilter.motiveOccurrence,
      hasAttachment: this.currentFilter.hasAttachment,
      hasNotes: this.currentFilter.hasNotes,
      lane: this.currentFilter.lane,
      startDate: this.currentFilter.startDate,
      endDate: this.currentFilter.endDate,
      contractId: this.currentFilter.contractId,
      device: this.currentFilter.device,
      sortBy: this.currentFilter.sortBy,
      sortOrder: this.currentFilter.sortOrder
    };

    this.occurrenceService.exportFilteredOccurrences(filter)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.exportLoading = false)
      )
      .subscribe({
        next: (blob: Blob) => {
          this.exportBlob = blob;
          this.exportReady = true;
        },
        error: () => {
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao exportar ocorrências'
          });
        }
      });
  }
 

  downloadExport() {
    if (!this.exportBlob) return;

    const url = URL.createObjectURL(this.exportBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `ocorrencias_${new Date().toISOString().slice(0, 10)}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    this.exportReady = false;
    this.exportBlob = null;
  }

  clearFilter() {
    this.occurrenceFilter = new OccurrenceFilterModel();
    this.occurrenceFilter.contractId = this.contracts[0]?.id;
    this.rangeDates = [];
    this.rangeDates[0] = this.occurrenceFilter.startDate;
    this.rangeDates[1] = this.occurrenceFilter.endDate;
    // this.motives = [];
    this.selectedSort = '';
    this.sortDirection = 0;
    this.selectedLotes = [];
    this.devices = [...this.allDevices];
    this.exportReady = false;
    this.exportBlob = null;

    this.getOccurrence(false, this.occurrenceFilter);
  }

  verifyVariables(): boolean {
    if (this.rangeDates !== undefined && this.rangeDates !== null) {
      if(this.rangeDates.length===0){
        return true;
      }
      if(this.rangeDates[1]===null){
        return false;
      }
    }
    return true;
  }

  returnRejectedLabel(rejected: any){
    if(rejected === true){
      return 'Sim'
    }else if(rejected === false){
      return 'Não'
    }else{
      return '-'
    }
  }

  ngOnDestroy() {
    this.closePreview();
    this._destroy$.next();
    this._destroy$.complete();
  }
}
